import monitor, { EVENT_TYPES } from '../../../../../../service/bigquery';
import { convertTagPageId } from '../../convertTagPageId';
import { PAGE_TYPE_INDUSTRY } from '../../constants';
import { getIdeaPageName } from '../getIdeaPageName';

/**
 * @typedef Input
 * @property {String} pageTagType
 * @property {String} pageTagId
 * @property {String} brandName
 * @property {String} slogan
 * @property {String} elementName
 * @property {String} elementText
 * @property {String} pageCtxId
 * @param {Input}
 * @returns {void}
 */
export const inspirationFieldsChanged = ({
    pageTagType,
    pageTagId,
    brandName,
    slogan,
    elementName,
    elementText,
    pageCtxId,
}) => {
    const industries = pageTagType === PAGE_TYPE_INDUSTRY ? convertTagPageId(pageTagId) : '';
    const sendData = {
        page: {
            name: getIdeaPageName(pageTagType, pageTagId),
            referrer: {
                ctx_id: pageCtxId,
            },
            element: {
                name: elementName,
                text: elementText,
            },
        },
        out_of_session: false,
        feature: { name: 'logo_maker' },
        makers_project: {
            brief: {
                industries,
                metadata: JSON.stringify({
                    brand_name: brandName,
                    slogan,
                }),
            },
        },
    };

    monitor.track(EVENT_TYPES.LISTINGS_BRIEF_METADATA_UPDATED, sendData);
};
